import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PaymentFailPage } from './payment-fail.page';

const routes: Routes = [
  {
    path: '',
    component: PaymentFailPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PaymentFailPageRoutingModule {}
